const CustomCheckbox = ({ 
    checked, 
    onChange, 
    label 
  }: { 
    checked: boolean; 
    onChange: () => void; 
    label: string;
  }) => (
    <label className="flex items-center gap-3 text-sm cursor-pointer group">
      <div className="relative">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="sr-only"
        />
        <div className={`w-5 h-5 border-2 rounded transition-all duration-200 flex items-center justify-center
          ${checked 
            ? 'bg-[#ff4e1d] border-[#ff4e1d]' 
            : 'bg-white border-gray-300 group-hover:border-[#ff4e1d]'
          }`}
        >
          {checked && (
            <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>
      </div>
      <span className={`text-gray-700 transition-colors ${checked ? 'text-[#ff4e1d] font-medium' : ''}`}>
        {label}
      </span>
    </label>
  );

export default CustomCheckbox